<template>
  <div class="qa-dashboard-wrapper">
    <router-view />
  </div>
</template>

<style scoped>
.qa-dashboard-wrapper {
  --qa-wrap-bg: #f8fafc;

  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  min-height: 0;
  overflow: auto;
  padding: 0;
  box-sizing: border-box;
  background: var(--qa-wrap-bg);
  color-scheme: light;
}
</style>

<style>
/* Mix: light content surface (dark chrome). Dark: follow dark page tokens.
 *
 * Mix sets BOTH body classes, so the dark rule must exclude it explicitly —
 * equal specificity means source order alone decided the winner, and the dark
 * block is written last. Symptom was a black strip down the right edge of any
 * QA page long enough to scroll: the app paints scrollbar tracks transparent
 * (_woot.scss), so the track showed this element's own background, and Mix was
 * silently getting the dark one. */
body.theme-mix .qa-dashboard-wrapper {
  --qa-wrap-bg: #f8fafc;
  background: #f8fafc !important;
  color: #111827 !important;
  color-scheme: light;

  /* The thumb vars are set globally on body.dark, which Mix also carries; left
   * alone the thumb is white-on-white and the scrollbar vanishes. */
  --wlab-scrollbar-color: rgba(0, 0, 0, 0.2);
  --wlab-scrollbar-thumb: rgba(0, 0, 0, 0.12);
  --wlab-scrollbar-thumb-hover: rgba(0, 0, 0, 0.22);
}

body.dark:not(.theme-mix) .qa-dashboard-wrapper {
  --qa-wrap-bg: #151820;
  background: #151820 !important;
  color: #ffffff !important;
  color-scheme: dark;
}
</style>
